import z from 'zod';

/** Indicate the status of the payments related to a given contract
 *
 * The possible statuses are:
 * - draft: the users is editing the contract.
 * - sent: the contracts has been sent to the client. The user can't edit the contract anymore.
 * - viewed: the contract has been seen by the client.
 * - signed: the contract has been signed by the client.
 * - declined: the client has declined the contract.
 * - paid: the contract has been fully paid by the client.
 * - expired: The document expired and is no longer available for completion or signature.
 * - voided: the document is not valid no more, the user might have created a new one.
 *
 */
export const contractStatusEnumSchema = z.enum([
  // the users is editing the contract.
  'draft',
  // the contracts has been sent to the client. The user can't edit the contract anymore.
  'sent',
  // the contract has been seen by the client.
  'viewed',
  // the contract has been signed by the client.
  'signed',
  // the client has declined the contract.
  'declined',
  // the client has paid the initial deposit.
  'deposit',
  // the contract has been fully paid by the client.
  'paid',
  // The document expired and is no longer available for completion or signature.
  'expired',
  // the document is not valid no more, the user might have created a new one.
  'voided',
  // the contract has been signed and the initial deposit has been received.
  'closed',
  // the customer has undergone surgery
  'completed',
]);

export type ContractStatusEnum = z.infer<typeof contractStatusEnumSchema>;
